import { SharedLinkExpiration } from 'common/models/sharing';

const SHARED_LINK_EXPIRATIONS = [
  SharedLinkExpiration.ONE_CLICK,
  SharedLinkExpiration.ONE_DAY,
  SharedLinkExpiration.NO_EXPIRATION,
];

export default SHARED_LINK_EXPIRATIONS;
